import React from "react";

const InlineStepIcon = () => (
  <svg width="120" height="80" viewBox="0 0 120 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke="#8089a8" stroke-width="2" stroke-dasharray="4 4" d="M10 40h100" />
    <circle cx="20" cy="40" r="4" fill="#8089a8" />
    <circle cx="60" cy="40" r="4" fill="#8089a8" />
    <circle cx="100" cy="40" r="4" fill="#8089a8" />
    <path stroke="#8089a8" stroke-width="2" d="M60 40V20" />
    <rect x="42" y="6" width="36" height="20" rx="4" stroke="#8089a8" stroke-width="2" />
    <circle cx="50" cy="16" r="2" fill="#8089a8" />
    <circle cx="60" cy="16" r="2" fill="#8089a8" />
    <circle cx="70" cy="16" r="2" fill="#8089a8" />
  </svg>
);

export default InlineStepIcon;
